export enum DeviceConfigurationTargetStatus {
  RETRIEVED = 'RETRIEVED',
  EMPTY = 'EMPTY',
  READY = 'READY',
  DOWNLOADED = 'DOWNLOADED',
  ACKNOWLEDGED = 'ACKNOWLEDGED',
  ERROR = 'ERROR'
}
